import React from "react";
import { Link } from "react-router-dom";
import "./components/AboutUs.css";

const AboutMortbuzz = () => {
  const highlights = [
    {
      icon: "bi bi-bank",
      title: "Multiple Lending Partners",
      text: "Compare suitable loan options from leading public and private sector banks.",
    },
    {
      icon: "bi bi-file-earmark-check",
      title: "Complete Documentation Support",
      text: "Receive assistance with document collection, verification and bank submission.",
    },
    {
      icon: "bi bi-headset",
      title: "Dedicated Loan Assistance",
      text: "Get professional guidance throughout the application and disbursement process.",
    },
  ];

  return (
    <section
      className="about-monayra-section"
      aria-labelledby="about-monayra-title"
    >
      <div
        className="about-monayra-glow about-monayra-glow-left"
        aria-hidden="true"
      ></div>

      <div
        className="about-monayra-glow about-monayra-glow-right"
        aria-hidden="true"
      ></div>

      <div className="about-monayra-container">
        <div className="about-monayra-visual">
          <div className="about-monayra-image-frame">
            <img
              src="/images/FrontPage/a-high-fashion-portrait-of-a-young-india_iXMJmzJzSnWhjVmfCPitfw_wTgFyOfrSceM-ko6rRf_kQ.jpeg"
              alt="Monayra loan consultant assisting customers in Pune"
              className="about-monayra-image"
              loading="lazy"
            />

            <div className="about-monayra-image-overlay"></div>

            <div className="about-monayra-experience-card">
              <span className="about-monayra-experience-icon">
                <i className="bi bi-award"></i>
              </span>

              <div>
                <strong>10+ Years</strong>
                <span>Loan Assistance Experience</span>
              </div>
            </div>

            <div className="about-monayra-support-card">
              <i className="bi bi-shield-check"></i>

              <div>
                <strong>Trusted Support</strong>
                <span>From application to disbursement</span>
              </div>
            </div>
          </div>
        </div>

        <div className="about-monayra-content">
          <span className="about-monayra-eyebrow">
            About Monayra
          </span>

          <h2 id="about-monayra-title">
            Professional loan assistance for
            <span> every financial goal</span>
          </h2>

          <p className="about-monayra-intro">
            Monayra Solutions India Pvt. Ltd. helps customers explore and apply
            for suitable loan products through a simple, transparent and
            professionally supported process.
          </p>

          <p className="about-monayra-description">
            We assist with home loans, personal loans, business loans,
            commercial loans, car loans, education loans and loans against
            property. Our team supports customers with lender comparison,
            documentation, application processing and regular follow-ups until
            disbursement.
          </p>

          <div className="about-monayra-highlights">
            {highlights.map((item) => (
              <article
                className="about-monayra-highlight"
                key={item.title}
              >
                <span className="about-monayra-highlight-icon">
                  <i className={item.icon}></i>
                </span>

                <div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="about-monayra-actions">
            <Link
              to="/apply-now"
              className="about-monayra-primary-btn"
            >
              <span>Apply for a Loan</span>
              <i className="bi bi-arrow-right"></i>
            </Link>

            <Link
              to="/mortbuzz-home-loan-offer"
              className="about-monayra-secondary-btn"
            >
              <i className="bi bi-grid"></i>
              Explore Services
            </Link>
          </div>

          <div className="about-monayra-trust-row">
            <div>
              <i className="bi bi-check-circle"></i>
              Transparent process
            </div>

            <div>
              <i className="bi bi-check-circle"></i>
              Doorstep assistance
            </div>

            <div>
              <i className="bi bi-check-circle"></i>
              Multiple loan products
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMortbuzz;